import { defineMeta } from '@/registry/types';

export const selectMeta = defineMeta({
  name: 'Select',
  level: 'atom',
  category: 'input',
  classification: 'themed-mui',
  description: 'Dropdown for choosing one (or many) option(s) from a list. Themed MUI Select.',
  baseLibrary: '@mui/material',
  muiEquivalent: 'Select',
  muiDocs: 'https://mui.com/material-ui/react-select/',
  a2uiEquivalent: 'Dropdown',
  importPath: '@/atoms/Select',
  optionalProps: ['value', 'multiple', 'label', 'disabled', 'onChange', 'size'],
  props: [
    {
      name: 'size',
      type: "'small' | 'medium'",
      default: 'medium',
      description:
        'Outer height from `controlHeights` (small=28, medium=36), matching Button and TextField of the same size.',
    },
  ],
  supportedStates: ['default', 'open', 'selected', 'disabled', 'error'],
  designTokens: ['colors', 'radius', 'controlHeights'],
  accessibility: [
    'Pair with InputLabel via labelId for an accessible name.',
    'Keyboard: Enter/Space opens; arrows navigate; Esc closes.',
  ],
  usageExamples: ['<Select label="Region"><MenuItem value="a">A</MenuItem></Select>'],
  rules: [
    'Pick `size` from context the same way as Button and TextField: default `medium` (36px) beside medium buttons; `small` (28px) in dense toolbars and tables.',
  ],
  antiPatterns: ['Do not use Select for fewer than 3 options (use Radio).', 'Avoid for searchable lists (use Autocomplete).'],
  llmSafe: true,
  whenToUse: ['Choosing from a medium/large set of known options'],
  whenNotToUse: ['Free-text entry', 'Very small option sets'],
});

export default selectMeta;
